export const PAGE_TRANSITION_DURATION = 1.4; // in seconds
